import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateTrips() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ids, values }) => {
      return Promise.all(
        ids.map((id) =>
          api.patch(`trips/${id}`, {
            headers: { 'content-type': 'application/merge-patch+json' },
            json: values,
          }),
        ),
      );
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['trips'] }),
  });
}
